import React, {Component} from 'react';
import { Redirect, Route } from "react-router-dom";
import { inject, observer } from "mobx-react";

@inject("user")
@observer
class AciRoute extends Component {
  redirectToLive = () => {
    if (localStorage.token) {
      return {url: '/webinars', state: {}};
    } else {
      return {url: '/online_workshops', state: {webinar: true}};
    }
  }

  render() {
    const {user, component: Component, ...rest} = this.props;
    const currentUser = user.getUser();
    const params = this.redirectToLive();
    return (
      <Route
        {...rest}
        render={props =>
          currentUser && (currentUser.governing_body === "aci" || currentUser.role === 'admin') ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: params.url,
                state: { from: props.location, ...params.state }
              }}
            />
          )
        }
      />
    );
  }
};

export default AciRoute;



// WEBPACK FOOTER //
// ./src/components/AciRoute.jsx